// Extended quiz questions for all modules

export const quizQuestions = {
  module1: [
    {
      id: 1,
      question: "What does OSHA stand for?",
      options: [
        "Occupational Safety and Health Administration",
        "Office of Safety and Hazard Assessment",
        "Organization for Secure and Healthy Atmospheres",
        "Operational Standards for Health Assurance"
      ],
      correctAnswer: 0,
      explanation: "OSHA stands for Occupational Safety and Health Administration, a federal agency under the Department of Labor."
    },
    {
      id: 2,
      question: "What is the primary purpose of OSHA?",
      options: [
        "To increase company profits",
        "To ensure safe and healthful working conditions",
        "To reduce employee work hours",
        "To manage employee benefits"
      ],
      correctAnswer: 1,
      explanation: "OSHA's mission is to ensure safe and healthful working conditions for workers by setting and enforcing standards."
    },
    {
      id: 3,
      question: "Under OSHA, who is responsible for providing a safe workplace?",
      options: [
        "Only the employees",
        "Only OSHA inspectors",
        "The employer",
        "The local government"
      ],
      correctAnswer: 2,
      explanation: "Employers are responsible for providing a workplace free from recognized hazards and must comply with OSHA standards."
    },
    {
      id: 4,
      question: "What is the General Duty Clause?",
      options: [
        "A requirement for employees to wear uniforms",
        "A clause requiring employers to provide a hazard-free workplace",
        "A rule about working hours",
        "A guideline for lunch breaks"
      ],
      correctAnswer: 1,
      explanation: "The General Duty Clause (Section 5(a)(1)) requires employers to provide a workplace free from recognized hazards."
    },
    {
      id: 5,
      question: "What year was OSHA established?",
      options: [
        "1960",
        "1970",
        "1980",
        "1990"
      ],
      correctAnswer: 1,
      explanation: "OSHA was created by the Occupational Safety and Health Act, signed into law on December 29, 1970."
    }
  ],
  module2: [
    {
      id: 1,
      question: "Which of the following is a physical hazard?",
      options: [
        "Bacteria",
        "Stress",
        "Noise",
        "Chemical fumes"
      ],
      correctAnswer: 2,
      explanation: "Noise is a physical hazard. Physical hazards include noise, radiation, vibration, and extreme temperatures."
    },
    {
      id: 2,
      question: "What is the correct order of the Hierarchy of Controls?",
      options: [
        "PPE, Engineering, Administrative, Elimination",
        "Elimination, Substitution, Engineering, Administrative, PPE",
        "Administrative, PPE, Engineering, Elimination",
        "Engineering, Elimination, Administrative, PPE"
      ],
      correctAnswer: 1,
      explanation: "The Hierarchy of Controls goes from most effective to least: Elimination, Substitution, Engineering Controls, Administrative Controls, and PPE."
    },
    {
      id: 3,
      question: "What is a Job Hazard Analysis (JHA)?",
      options: [
        "A performance review",
        "A technique to identify hazards in job tasks",
        "A salary calculation method",
        "An employee satisfaction survey"
      ],
      correctAnswer: 1,
      explanation: "A JHA is a technique that focuses on job tasks to identify hazards before they occur and determine ways to reduce or eliminate them."
    },
    {
      id: 4,
      question: "Which type of hazard includes mold and bloodborne pathogens?",
      options: [
        "Physical hazards",
        "Chemical hazards",
        "Biological hazards",
        "Ergonomic hazards"
      ],
      correctAnswer: 2,
      explanation: "Biological hazards include bacteria, viruses, fungi (mold), bloodborne pathogens, and other living organisms."
    },
    {
      id: 5,
      question: "What is the most effective control in the Hierarchy of Controls?",
      options: [
        "PPE",
        "Administrative controls",
        "Engineering controls",
        "Elimination"
      ],
      correctAnswer: 3,
      explanation: "Elimination is the most effective control because it completely removes the hazard from the workplace."
    }
  ],
  module3: [
    {
      id: 1,
      question: "When should PPE be used according to the Hierarchy of Controls?",
      options: [
        "As the first line of defense",
        "Only when other controls are not feasible",
        "Never - it's not effective",
        "Only for office workers"
      ],
      correctAnswer: 1,
      explanation: "PPE is the last line of defense and should be used when hazards cannot be adequately controlled through elimination, substitution, engineering, or administrative controls."
    },
    {
      id: 2,
      question: "What does the ANSI Z87.1 standard relate to?",
      options: [
        "Hard hats",
        "Eye and face protection",
        "Hearing protection",
        "Foot protection"
      ],
      correctAnswer: 1,
      explanation: "ANSI Z87.1 is the standard for occupational and educational eye and face protection devices."
    },
    {
      id: 3,
      question: "Who is responsible for providing PPE in the workplace?",
      options: [
        "The employee",
        "The employer",
        "OSHA",
        "The insurance company"
      ],
      correctAnswer: 1,
      explanation: "Under OSHA regulations, employers must provide and pay for required PPE, with few exceptions."
    },
    {
      id: 4,
      question: "What should you check before using any PPE?",
      options: [
        "The brand name",
        "Its condition and proper fit",
        "The color",
        "The price tag"
      ],
      correctAnswer: 1,
      explanation: "Always inspect PPE for damage and ensure proper fit before each use to guarantee protection."
    },
    {
      id: 5,
      question: "At what noise level (dB) must employers implement a hearing conservation program?",
      options: [
        "65 dB",
        "75 dB",
        "85 dB",
        "95 dB"
      ],
      correctAnswer: 2,
      explanation: "OSHA requires a hearing conservation program when workers are exposed to 85 decibels or higher over an 8-hour period."
    }
  ],
  module4: [
    {
      id: 1,
      question: "What does the acronym PASS stand for in fire extinguisher use?",
      options: [
        "Push, Aim, Squeeze, Sweep",
        "Pull, Aim, Squeeze, Sweep",
        "Point, Activate, Spray, Stop",
        "Prepare, Aim, Spray, Secure"
      ],
      correctAnswer: 1,
      explanation: "PASS stands for Pull the pin, Aim at the base of the fire, Squeeze the handle, and Sweep side to side."
    },
    {
      id: 2,
      question: "What are the three elements of the fire triangle?",
      options: [
        "Water, smoke, flames",
        "Heat, fuel, oxygen",
        "Spark, wood, air",
        "Electricity, gas, paper"
      ],
      correctAnswer: 1,
      explanation: "The fire triangle consists of heat, fuel, and oxygen. Remove any one element to extinguish a fire."
    },
    {
      id: 3,
      question: "What type of fire extinguisher should be used on electrical fires?",
      options: [
        "Class A (water)",
        "Class B (foam)",
        "Class C (CO2 or dry chemical)",
        "Class D (metal)"
      ],
      correctAnswer: 2,
      explanation: "Class C extinguishers (CO2 or dry chemical) are designed for electrical fires because they don't conduct electricity."
    },
    {
      id: 4,
      question: "What is an Emergency Action Plan (EAP)?",
      options: [
        "A plan for company parties",
        "A written document for emergency situations",
        "A marketing strategy",
        "A hiring procedure"
      ],
      correctAnswer: 1,
      explanation: "An EAP is a written document required by OSHA that outlines procedures for emergencies like fires, evacuations, and severe weather."
    },
    {
      id: 5,
      question: "How often should fire drills be conducted in most workplaces?",
      options: [
        "Once a year",
        "At least annually, preferably quarterly",
        "Only when there's an actual fire",
        "Every five years"
      ],
      correctAnswer: 1,
      explanation: "Fire drills should be conducted at least annually, with many experts recommending quarterly drills for optimal preparedness."
    }
  ],
  module5: [
    {
      id: 1,
      question: "What does LOTO stand for?",
      options: [
        "Lock Out, Tag Out",
        "Look Out, Take Over",
        "Locate, Operate, Test, Observe",
        "Load Out, Turn Off"
      ],
      correctAnswer: 0,
      explanation: "LOTO stands for Lockout/Tagout, a safety procedure to ensure machines are properly shut off during maintenance."
    },
    {
      id: 2,
      question: "What is the purpose of a GFCI?",
      options: [
        "To increase electrical power",
        "To protect against ground faults and electrocution",
        "To reduce electricity bills",
        "To measure voltage"
      ],
      correctAnswer: 1,
      explanation: "A Ground Fault Circuit Interrupter (GFCI) protects against electrical shock by detecting ground faults and shutting off power."
    },
    {
      id: 3,
      question: "What should you do before working on electrical equipment?",
      options: [
        "Assume it's safe if it looks off",
        "De-energize and verify zero energy state",
        "Work quickly to minimize exposure",
        "Wear rubber gloves only"
      ],
      correctAnswer: 1,
      explanation: "Always de-energize equipment and verify zero energy state using proper testing equipment before any work."
    },
    {
      id: 4,
      question: "What is arc flash?",
      options: [
        "A type of welding",
        "A dangerous electrical explosion",
        "A photography technique",
        "A type of light bulb"
      ],
      correctAnswer: 1,
      explanation: "Arc flash is a dangerous electrical explosion that can cause severe burns, hearing damage, and death."
    },
    {
      id: 5,
      question: "Who can perform electrical work according to OSHA?",
      options: [
        "Anyone with basic training",
        "Only qualified persons",
        "Any maintenance worker",
        "Only electricians with 20+ years experience"
      ],
      correctAnswer: 1,
      explanation: "Only qualified persons who have training to recognize and avoid electrical hazards can work on electrical equipment."
    }
  ],
  module6: [
    {
      id: 1,
      question: "What does MSD stand for?",
      options: [
        "Material Safety Document",
        "Musculoskeletal Disorder",
        "Machine Safety Device",
        "Minimum Safe Distance"
      ],
      correctAnswer: 1,
      explanation: "MSD stands for Musculoskeletal Disorder, injuries affecting muscles, nerves, tendons, joints, and cartilage."
    },
    {
      id: 2,
      question: "What is the proper lifting technique?",
      options: [
        "Bend at the waist, keep legs straight",
        "Bend at the knees, keep back straight",
        "Twist while lifting for momentum",
        "Lift quickly to reduce strain"
      ],
      correctAnswer: 1,
      explanation: "Proper lifting involves bending at the knees, keeping the back straight, and lifting with the legs, not the back."
    },
    {
      id: 3,
      question: "What is a primary cause of repetitive strain injuries?",
      options: [
        "One-time heavy lifting",
        "Performing the same motion repeatedly",
        "Standing for short periods",
        "Occasional typing"
      ],
      correctAnswer: 1,
      explanation: "Repetitive strain injuries are caused by performing the same motion repeatedly without adequate rest or recovery."
    },
    {
      id: 4,
      question: "What is the ideal monitor height for computer workstations?",
      options: [
        "Below desk level",
        "Top of screen at or slightly below eye level",
        "Above head level",
        "At chest level"
      ],
      correctAnswer: 1,
      explanation: "The top of the monitor should be at or slightly below eye level to reduce neck strain."
    },
    {
      id: 5,
      question: "How often should you take breaks when doing repetitive tasks?",
      options: [
        "Once a day",
        "Every 2-3 hours",
        "Every 30-60 minutes with micro-breaks",
        "Only when feeling pain"
      ],
      correctAnswer: 2,
      explanation: "Take short micro-breaks every 30-60 minutes to rest muscles, stretch, and change positions."
    }
  ],
  module7: [
    {
      id: 1,
      question: "At what height does OSHA require fall protection in general industry?",
      options: [
        "4 feet",
        "6 feet",
        "8 feet",
        "10 feet"
      ],
      correctAnswer: 0,
      explanation: "In general industry, OSHA requires fall protection at 4 feet. Construction requires it at 6 feet."
    },
    {
      id: 2,
      question: "What is a confined space?",
      options: [
        "A small office",
        "A space with limited entry/exit and not designed for continuous occupancy",
        "Any room without windows",
        "A storage closet"
      ],
      correctAnswer: 1,
      explanation: "A confined space has limited entry/exit, is large enough for a worker to enter, and is not designed for continuous occupancy."
    },
    {
      id: 3,
      question: "What must be present on machinery to prevent worker contact with moving parts?",
      options: [
        "Warning labels only",
        "Machine guards",
        "Speed limiters",
        "Instruction manuals"
      ],
      correctAnswer: 1,
      explanation: "Machine guards are physical barriers that prevent workers from contacting dangerous moving parts."
    },
    {
      id: 4,
      question: "What is the purpose of an SDS (Safety Data Sheet)?",
      options: [
        "To track employee hours",
        "To provide chemical hazard and safety information",
        "To record equipment purchases",
        "To document fire drills"
      ],
      correctAnswer: 1,
      explanation: "SDS provides detailed information about chemical hazards, handling, storage, and emergency procedures."
    },
    {
      id: 5,
      question: "What are the symptoms of heat stroke?",
      options: [
        "Excessive sweating and cool skin",
        "Hot dry skin, confusion, loss of consciousness",
        "Mild headache only",
        "Increased appetite"
      ],
      correctAnswer: 1,
      explanation: "Heat stroke symptoms include hot dry skin (no sweating), confusion, slurred speech, and loss of consciousness. It's a medical emergency."
    }
  ],
  module8: [
    {
      id: 1,
      question: "What is the OSHA 300 Log?",
      options: [
        "A log of employee attendance",
        "A record of work-related injuries and illnesses",
        "A list of safety equipment",
        "A training schedule"
      ],
      correctAnswer: 1,
      explanation: "The OSHA 300 Log is a form used to record and classify work-related injuries and illnesses."
    },
    {
      id: 2,
      question: "When must the OSHA 300A Summary be posted?",
      options: [
        "January 1 - April 30",
        "February 1 - April 30",
        "Year-round",
        "Only during OSHA inspections"
      ],
      correctAnswer: 1,
      explanation: "The OSHA 300A Summary must be posted from February 1 to April 30 each year."
    },
    {
      id: 3,
      question: "What is the goal of an incident investigation?",
      options: [
        "To assign blame to workers",
        "To identify root causes and prevent recurrence",
        "To satisfy insurance requirements only",
        "To document for legal purposes only"
      ],
      correctAnswer: 1,
      explanation: "The primary goal is to identify root causes and implement corrective actions to prevent similar incidents."
    },
    {
      id: 4,
      question: "How long must OSHA injury records be retained?",
      options: [
        "1 year",
        "3 years",
        "5 years",
        "10 years"
      ],
      correctAnswer: 2,
      explanation: "OSHA requires employers to retain injury and illness records for 5 years following the end of the calendar year."
    },
    {
      id: 5,
      question: "What is the purpose of a safety inspection checklist?",
      options: [
        "To waste time",
        "To systematically identify hazards and ensure compliance",
        "To impress OSHA inspectors",
        "To create paperwork"
      ],
      correctAnswer: 1,
      explanation: "Safety checklists help systematically identify hazards, ensure consistent inspections, and maintain compliance."
    }
  ]
};

// Extended scenarios
export const scenarios = [
  {
    id: 1,
    title: "The Slippery Floor Incident",
    moduleId: 2,
    description: "You're a supervisor and notice a water leak near the main walkway during a busy shift.",
    situation: "A pipe has developed a small leak, creating a puddle in a high-traffic area. Workers are rushing to meet a deadline.",
    options: [
      { text: "Ignore it - it's small and workers should watch where they walk", correct: false, feedback: "Incorrect. Ignoring hazards violates OSHA's General Duty Clause and could lead to serious injuries." },
      { text: "Place a wet floor sign and continue working", correct: false, feedback: "Partially correct, but insufficient. Signs alone don't eliminate the hazard." },
      { text: "Immediately block off the area, place warning signs, and report for repair", correct: true, feedback: "Correct! This follows the hierarchy of controls by eliminating access to the hazard while ensuring it gets fixed." },
      { text: "Tell workers to be careful and walk around it", correct: false, feedback: "Incorrect. Verbal warnings alone are the least effective control and don't address the hazard." }
    ]
  },
  {
    id: 2,
    title: "The Missing Guard",
    moduleId: 7,
    description: "You notice a machine guard has been removed from a table saw.",
    situation: "A coworker removed the guard because 'it slows down production.' Other workers are waiting to use the machine.",
    options: [
      { text: "Use the machine carefully - you're experienced", correct: false, feedback: "Never operate machinery without proper guards. Experience doesn't prevent accidents." },
      { text: "Refuse to use it and report immediately to your supervisor", correct: true, feedback: "Correct! Lockout the machine if possible and report immediately. Machine guarding is required by OSHA." },
      { text: "Put the guard back yourself and continue working", correct: false, feedback: "While reinstalling is good, you should still report the issue to prevent future occurrences." },
      { text: "Wait for someone else to handle it", correct: false, feedback: "Incorrect. You have a responsibility to report hazards immediately - waiting puts others at risk." }
    ]
  },
  {
    id: 3,
    title: "Chemical Spill Response",
    moduleId: 4,
    description: "A container of unknown chemicals has spilled in the storage area.",
    situation: "You hear glass breaking and see a liquid spreading on the floor. There's a faint chemical odor.",
    options: [
      { text: "Grab paper towels and clean it up quickly", correct: false, feedback: "Never clean up unknown chemicals! You could be exposed to hazardous substances." },
      { text: "Evacuate the area, alert others, and check the SDS", correct: true, feedback: "Correct! Safety first - evacuate, alert others, then identify the chemical using the Safety Data Sheet before any response." },
      { text: "Open windows for ventilation and continue working", correct: false, feedback: "Incorrect. Unknown chemicals require proper hazmat response, not improvised solutions." },
      { text: "Call 911 immediately", correct: false, feedback: "While emergency services may be needed, first you should evacuate and identify the chemical to properly inform responders." }
    ]
  },
  {
    id: 4,
    title: "Electrical Work Without LOTO",
    moduleId: 5,
    description: "You observe a maintenance worker about to service electrical equipment.",
    situation: "The worker says they're 'just doing a quick fix' and haven't locked out the power because 'it'll only take a minute.'",
    options: [
      { text: "Let them continue - they know what they're doing", correct: false, feedback: "Incorrect. Lockout/Tagout is required regardless of how quick the job is. Many deaths occur during 'quick fixes.'" },
      { text: "Stop the work and insist on proper LOTO procedures", correct: true, feedback: "Correct! All employees have the right and responsibility to stop unsafe work. LOTO must always be followed." },
      { text: "Stand by to watch in case something happens", correct: false, feedback: "Watching doesn't prevent the accident. You need to stop the unsafe behavior." },
      { text: "Report it after they finish", correct: false, feedback: "Too late! The hazard exists now. Immediate intervention is required." }
    ]
  },
  {
    id: 5,
    title: "PPE Non-Compliance",
    moduleId: 3,
    description: "A new employee is working in a required safety glasses area without eye protection.",
    situation: "They say they forgot their glasses and don't want to walk back to get them. There's grinding work nearby creating sparks.",
    options: [
      { text: "Let them work - they'll be more careful", correct: false, feedback: "Incorrect. Being careful doesn't stop flying debris from causing eye injuries." },
      { text: "Stop work immediately and ensure they get proper PPE before continuing", correct: true, feedback: "Correct! Work must stop until proper PPE is obtained. Eye injuries can be permanent." },
      { text: "Give them your safety glasses and work without yours", correct: false, feedback: "Now you're at risk! Both workers need protection." },
      { text: "Have them stand far from the grinding work", correct: false, feedback: "Debris can travel far. The entire area requires eye protection - distance doesn't eliminate the requirement." }
    ]
  },
  {
    id: 6,
    title: "Ergonomic Concern",
    moduleId: 6,
    description: "A coworker complains of recurring wrist pain from repetitive assembly work.",
    situation: "They've been doing the same task for 8 hours straight with no breaks. They say it's 'just part of the job.'",
    options: [
      { text: "Agree that some discomfort is normal", correct: false, feedback: "Incorrect. Pain is your body's warning signal. Ignoring it leads to serious MSDs." },
      { text: "Suggest they take regular breaks, report the issue, and request an ergonomic assessment", correct: true, feedback: "Correct! Early intervention prevents serious injuries. Employers must address ergonomic hazards." },
      { text: "Tell them to work through the pain", correct: false, feedback: "This can lead to permanent damage. Repetitive strain injuries worsen without intervention." },
      { text: "Suggest they see a doctor but continue working the same way", correct: false, feedback: "Medical care helps, but the root cause (the work conditions) must also be addressed." }
    ]
  }
];

// Course stats (can be dynamic in real implementation)
export const courseStats = [
  { value: "8,500+", label: "Workers Trained" },
  { value: "40+", label: "Course Hours" },
  { value: "15+", label: "Interactive Scenarios" },
  { value: "98%", label: "Compliance Rate" }
];

export const previewModules = [
  {
    id: 1,
    title: "OSHA Basics Explained",
    description: "Understand OSHA regulations and why workplace safety matters",
    duration: "10 min preview",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Hazard Identification Walkthrough",
    description: "Learn to spot common workplace hazards before they cause harm",
    duration: "15 min preview",
    icon: "AlertTriangle"
  },
  {
    id: 3,
    title: "PPE Selection Guide",
    description: "Hands-on guide to choosing the right protective equipment",
    duration: "12 min preview",
    icon: "HardHat"
  },
  {
    id: 4,
    title: "Emergency Response Basics",
    description: "Critical steps for handling workplace emergencies",
    duration: "8 min preview",
    icon: "Siren"
  }
];

export const curriculum = [
  {
    id: 1,
    title: "Introduction to OSHA & Workplace Safety",
    duration: "1 week",
    topicCount: 6,
    topics: [
      "What is OSHA and Its Mission",
      "Understanding Workers' Rights",
      "Employer Responsibilities Under OSHA",
      "Overview of OSHA Standards (29 CFR)",
      "The Importance of Safety Culture",
      "Penalties and Citations Explained"
    ]
  },
  {
    id: 2,
    title: "Hazard Recognition & Risk Assessment",
    duration: "1.5 weeks",
    topicCount: 7,
    topics: [
      "Types of Workplace Hazards",
      "Physical, Chemical, and Biological Hazards",
      "Ergonomic and Psychosocial Hazards",
      "Conducting a Job Hazard Analysis (JHA)",
      "Risk Assessment Matrices",
      "Hierarchy of Controls",
      "Creating a Hazard Communication Program"
    ]
  },
  {
    id: 3,
    title: "Personal Protective Equipment (PPE)",
    duration: "1 week",
    topicCount: 6,
    topics: [
      "PPE Requirements and Selection Criteria",
      "Head, Eye, and Face Protection",
      "Hearing Conservation",
      "Respiratory Protection Programs",
      "Hand and Foot Protection",
      "PPE Inspection and Maintenance"
    ]
  },
  {
    id: 4,
    title: "Fire Safety & Emergency Preparedness",
    duration: "1 week",
    topicCount: 6,
    topics: [
      "Fire Triangle and Prevention Methods",
      "Fire Extinguisher Types and Usage (PASS)",
      "Emergency Action Plans (EAP)",
      "Evacuation Procedures and Routes",
      "First Aid and CPR Basics",
      "Emergency Response Drills"
    ]
  },
  {
    id: 5,
    title: "Electrical Safety",
    duration: "1 week",
    topicCount: 6,
    topics: [
      "Electrical Hazards Overview",
      "Lockout/Tagout (LOTO) Procedures",
      "Ground Fault Circuit Interrupters (GFCI)",
      "Safe Work Practices Near Electricity",
      "Arc Flash and Shock Prevention",
      "Electrical Equipment Inspection"
    ]
  },
  {
    id: 6,
    title: "Ergonomics & Manual Material Handling",
    duration: "1 week",
    topicCount: 6,
    topics: [
      "Understanding Musculoskeletal Disorders (MSDs)",
      "Proper Lifting Techniques",
      "Workstation Ergonomics",
      "Repetitive Motion Injury Prevention",
      "Material Handling Equipment Safety",
      "Ergonomic Assessment Tools"
    ]
  },
  {
    id: 7,
    title: "Specialized Safety Topics",
    duration: "1.5 weeks",
    topicCount: 7,
    topics: [
      "Fall Protection and Prevention",
      "Confined Space Entry",
      "Machine Guarding Essentials",
      "Bloodborne Pathogens",
      "Workplace Violence Prevention",
      "Heat and Cold Stress Management",
      "Chemical Safety and SDS Sheets"
    ]
  },
  {
    id: 8,
    title: "Compliance, Recordkeeping & Certification",
    duration: "1 week",
    topicCount: 6,
    topics: [
      "OSHA 300 Log Requirements",
      "Incident Investigation Procedures",
      "Safety Inspection Checklists",
      "Creating Safety Policies",
      "Final Assessment & Certification",
      "Continuous Improvement Strategies"
    ]
  }
];

export const skills = [
  "Hazard Recognition",
  "Risk Assessment",
  "PPE Selection",
  "Emergency Response",
  "OSHA Compliance",
  "Incident Investigation",
  "Safety Auditing",
  "JHA Development"
];

export const faqData = [
  {
    question: "Is this course OSHA-certified?",
    answer: "This course covers essential OSHA safety topics and prepares you for OSHA compliance. While it provides comprehensive safety training aligned with OSHA standards, official OSHA certification requires completion through OSHA-authorized providers. This course is designed as an educational resource and lead-in to proper workplace safety practices."
  },
  {
    question: "Who should take this course?",
    answer: "This course is ideal for safety managers, supervisors, HR professionals, business owners, and any employee who wants to understand workplace safety fundamentals. It's especially valuable for small to medium businesses looking to establish or improve their safety programs."
  },
  {
    question: "How long does the course take to complete?",
    answer: "The full course contains approximately 40+ hours of content spread across 8 modules. You can complete it at your own pace, with most learners finishing within 8-10 weeks when dedicating 4-5 hours per week."
  },
  {
    question: "Are there quizzes and assessments?",
    answer: "Yes! Each module includes interactive quizzes to reinforce learning, scenario-based assessments, and a final comprehensive exam. You'll receive a certificate of completion after passing all assessments with a score of 80% or higher."
  },
  {
    question: "Can I access the course on mobile devices?",
    answer: "Absolutely! The course is fully responsive and works on desktops, tablets, and smartphones. Learn anytime, anywhere that's convenient for you."
  },
  {
    question: "What's included with the free course?",
    answer: "The free course includes all 8 modules with 40+ hours of content, interactive scenarios, quizzes, and a certificate of completion. It's our way of helping businesses improve workplace safety while introducing you to WSafe AI™'s comprehensive compliance platform."
  },
  {
    question: "How does this connect to WSafe AI™?",
    answer: "This course teaches you the fundamentals of OSHA compliance. WSafe AI™ takes it further by automating your safety management—digital forms, AI-powered audits, incident tracking, and instant compliance reports. Together, they create a complete safety solution for your workplace."
  },
  {
    question: "Is there support if I have questions?",
    answer: "Yes! You can reach out to our support team anytime. We also have an AI assistant built into the platform to answer common safety questions instantly."
  }
];

export const courseHighlights = [
  { value: "15+", label: "Interactive Scenarios" },
  { value: "40+", label: "Hours of Content" },
  { value: "8", label: "Comprehensive Modules" },
  { value: "Lifetime", label: "Access & Updates" }
];

export const testimonials = [
  {
    name: "Michael Torres",
    role: "Operations Manager",
    company: "BuildRight Construction",
    content: "This course transformed how we approach safety. Our incident rate dropped 45% within 6 months of implementing what we learned.",
    avatar: "MT"
  },
  {
    name: "Sarah Chen",
    role: "HR Director",
    company: "Pacific Manufacturing",
    content: "Finally, a safety course that's engaging and practical. Our team actually enjoys the training now, and it shows in our compliance scores.",
    avatar: "SC"
  },
  {
    name: "James Wilson",
    role: "Safety Coordinator",
    company: "LogiFreight Inc.",
    content: "The interactive scenarios are incredibly realistic. They've helped our supervisors make better split-second safety decisions.",
    avatar: "JW"
  }
];
